import React, {useEffect, useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Checkboxes from "../../Form/Checkboxes.tsx";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';

const TabPermits = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [statusAndPermitList, setStatusAndPermitList] = useState<Array<any>>([]);
    const [statusAndPermitLoading, setStatusAndPermitLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const { getList } = useListsApi();
    const [apiErrors, setApiErrors] = useState<any>();

    const [unSavedChanges, setUnSavedChanges] = useState(false);
    
    const [formData, setFormData] = useState<IProfile>({
        status_and_permit: profile.status_and_permit ?? [],
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const expectedAmountStatusAndPermits:number = 17;

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        let postedData:{status_and_permit:Array<string>} = {
            status_and_permit: [],
        };
        let statusAndPermitIds = formData.status_and_permit!.map(el => {
            return el.value;
        });
        postedData.status_and_permit = statusAndPermitIds;

        setErrors({});
        postProfile(postedData).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...postedData});
                    setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        let formDataClone = structuredClone(formData);
        getList('status_and_permit').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setStatusAndPermitList(optionList);
                let statusAndPermitsFromOptions:Array<IOption> = [];
                statusAndPermitsFromOptions = optionList.filter(singleStatusAndPermitOption => {
                    return profile.status_and_permit?.includes(singleStatusAndPermitOption.value);
                });
                setFormData({ ...formDataClone, status_and_permit: statusAndPermitsFromOptions });
                setStatusAndPermitLoading(false);
            }
        }).catch(() => {
            setApiErrors({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setStatusAndPermitLoading(false);
        });
    }, []);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                intro={'Bitte markieren Sie Ihre Zulassungen und Erlaubnisse. Die Auswahl ist auch Basis für die Suche auf der FPSB-Webseite.'}
            >
                { statusAndPermitLoading ? (
                    <div className="form-group checkboxes no-label">
                        <div className="checkbox-inputs-wrapper">
                            {[...Array(expectedAmountStatusAndPermits)].map((k,i) =>
                                <div className="single-checkbox" key={'sap_' + i}>
                                    <input type="checkbox" disabled />
                                    <label><div className="checkbox-loader"></div></label>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors ? apiErrors : null}>
                        <Checkboxes
                            name='status_and_permit'
                            onChange={(item:IOption, wasChecked:boolean) => {
                                if (wasChecked) {
                                    let x = formData.status_and_permit.filter(el => {
                                        return el.value !== item.value
                                    });
                                    handleChange(null, 'status_and_permit', x);
                                } else {
                                    let x = structuredClone(formData.status_and_permit);
                                    x.push(item);
                                    handleChange(null, 'status_and_permit', x);
                                }
                            }}
                            value={formData?.status_and_permit}
                            options={statusAndPermitList}
                            error={errors['status_and_permit']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabPermits;